import axios from "axios";
import { useState } from "react";

export default function PaymentMethodPopup({ show, onClose,onNext,onError /*onPay*/ }) {
    const [paymentMethod, setPaymentMethod] = useState("כרטיס אשראי");
    const [agree, setAgree] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const Url = `/member/dues/createRecurring/DUES/`;
    if (!show) return null;

    const handlePay = () => {
         ToPay(paymentMethod == "כרטיס אשראי" ? "SELF" : "MEMBER_FRIEND");
        // setIsLoading(true);
        // setTimeout(() => {
        //     ToPay(paymentMethod == "כרטיס אשראי" ? "SELF" : "MEMBER_FRIEND");
        //     setIsLoading(false);
        // }, 400);
    };



    const ToPay = async (paymentMethod) => {
          setIsLoading(true);
        try {
            const response = await axios.get(`${Url + paymentMethod}`, {
                headers: { 'Content-Type': 'application/json' }
            });

            if (response?.status === 200) {
                console.log(response)
                const data = response?.data;
                if (typeof data === 'string') {
                    // getTrainingDays();
                    console.log("onNext entered")
                    onNext(data);
                } else {
                    window.location.href = response?.data?.urlPage;
                }
            } else {
                   onError(response.response?.data?.message);
            }
        } catch (error) {
            // getTrainingDays();
            onError(error?.response?.data?.message);
        }
        finally {
          setIsLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4" dir="rtl">
            <div className="bg-white rounded-xl shadow-lg w-full max-w-md p-6 relative animate-fadeIn">

                {/* Close */}
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                >
                    ✕
                </button>

                <h2 className="text-lg font-bold text-blue-700 text-center mb-4">
                    בחירת אמצעי תשלום
                </h2>

                <div className="flex flex-col gap-3">

                    {/* בחירת אמצעי תשלום */}
                    <p className="text-right text-sm">בחר אמצעי תשלום:</p>

                    <div className="flex flex-col gap-2 text-sm">

                        <label className="flex items-center gap-2 justify-start cursor-pointer">
                            <input
                                type="radio"
                                name="payment"
                                value="כרטיס אשראי"
                                checked={paymentMethod === "כרטיס אשראי"}
                                onChange={() => setPaymentMethod("כרטיס אשראי")}
                            />
                            כרטיס אשראי
                        </label>

                        <label className="flex items-center gap-2 justify-start cursor-pointer">
                            <input
                                type="radio"
                                name="payment"
                                value="לקוח משלם"
                                checked={paymentMethod === "לקוח משלם"}
                                onChange={() => setPaymentMethod("לקוח משלם")}
                            />
                            לקוח משלם
                        </label>

                    </div>

                    {/* אישור תנאים */}
                    {paymentMethod === "לקוח משלם" && (
                        <div className="flex items-start gap-2 justify-end text-sm bg-gray-50 p-3 rounded-lg">
                            <input
                                type="checkbox"
                                checked={agree}
                                onChange={() => setAgree(!agree)}
                            />
                            <p className="text-right">
                                אני מאשר כי אני מודע לתנאים ולהתחייבויות הקורס ולמדיניות האתר.
                            </p>
                        </div>
                    )}

                    {/* כפתור שלם */}
                    <button
                        disabled={
                            isLoading ||
                            (paymentMethod === "לקוח משלם" && !agree)
                        }
                        onClick={handlePay}
                        className="w-full bg-blue-600 text-white py-2 rounded-lg font-semibold hover:bg-blue-700 transition shadow disabled:bg-gray-300"
                    >
                        {isLoading ? "מבצע תשלום..." : "שלם"}
                    </button>

                </div>

            </div>
        </div>
    );
}
